var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBurger = function SvgBurger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "burger_svg__svg-icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.5 307.2h614.4a20.48 20.48 0 1 0 0-40.96H177.5a20.48 20.48 0 1 0 0 40.96zm0 450.56h614.4a20.48 20.48 0 1 0 0-40.96H177.5a20.48 20.48 0 1 0 0 40.96zm0-225.28h614.4a20.48 20.48 0 1 0 0-40.96H177.5a20.48 20.48 0 1 0 0 40.96z"
  })));
};

export default SvgBurger;